export default "__VITE_ASSET__CNr4gIRt__"